import InjectedService from '../../../../../common/ts/core/services/InjectedService';

export default class InvoiceService extends InjectedService {
}
